<template lang="html">
    <b-modal v-model="showInfoModal" title="Callback Info"  @hide=" $emit('update:is-show', false)" hide-footer>
      <div>
        Will be added like: &event_callback_{token}=
      </div>
    </b-modal> 
</template>
<script>
    
export default {
    
    props: ['isShow'],
    data() {
        return {

        }
    },
    created(){

    },
    computed: {
        showInfoModal: {
            get: function() {
                return this.isShow
            },
            set: function() {

            }
        }
    },
    methods: {

    },    
}
</script>
<style scoped>

</style>